async function getStateFromPostcode(postcode = "") {
  try {
    const res = await fetch(`${window.location.origin}/apps/datajet/task/69b19c88bf4c0fb8753983f9`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: "r46ognjr964o6i49tpmjbcomfi6cv9",
      },
      body: JSON.stringify({ dropoff_postcode: postcode }),
    });
    const data = await res.json();
    console.log("state data", data);
    const locality = data?.localities?.locality;
    if (!locality) return [];
    const localities = Array.isArray(locality) ? locality : [locality];
    return [...new Set(localities.map((l) => l?.state).filter(Boolean))];
  } catch (error) {
    console.error("Error getting state from postcode", error);
    return [];
  }
}

/**
 * Shippit/Datajet API — returns courier quotes based on physical dimensions.
 * Payload dimensions: weight in kg, width/height/depth in metres.
 * Response: { response: [{ service_level, courier_type, quotes: [{ price, estimated_transit_time }] }], count }
 */
async function getShippitRates({ postcode = "", weightGrams = 1000, widthMm = 0, heightMm = 0, depthMm = 0 } = {}) {
  try {
    const res = await fetch(`${window.location.origin}/apps/datajet/task/690b3f49005e971604438cc2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: "npajnt2e8r1g28ebu7ta600se2vq0pb6f",
      },
      body: JSON.stringify({
        dropoff_postcode: postcode,
        weight: weightGrams / 1000,
        width: widthMm / 100,
        height: heightMm / 100,
        depth: depthMm / 100,
      }),
    });
    return await res.json();
  } catch (error) {
    console.error("Error getting Shippit rates", error);
    return null;
  }
}

/**
 * Shopify draftOrderCalculate via Datajet — returns shipping rates that mirror checkout.
 * Sends cart variant_ids; appends current product variant only if it's not already in cart.
 */
async function getShippingRates(zip = "", currentVariantId = "") {
  console.log("currentVariantId", currentVariantId);
  try {
    const cartRes = await fetch("/cart.json").then((res) => res.json());
    const variant_ids = cartRes.items.map((item) => item.variant_id);
    const isAlreadyInCart = cartRes.items.some(
      (item) => String(item.variant_id) === String(currentVariantId)
    );
    if (currentVariantId && !isAlreadyInCart) {
      variant_ids.push(currentVariantId);
    }
    console.log("variant_ids sent to draftOrderCalculate", variant_ids, "alreadyInCart:", isAlreadyInCart);
    const res = await fetch(`${window.location.origin}/apps/datajet/task/69b957340060569947c103c4`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: "33s93b0yoeyor4lzstf0zpgsgxxofkxgv",
      },
      body: JSON.stringify({ variant_ids, zip }),
    });
    return await res.json();
  } catch (error) {
    console.error("Error getting shipping rates", error);
    return null;
  }
}

class ShippingCalcToggle extends HTMLElement {
  connectedCallback() {
    this.targetSelector = this.getAttribute("target") || ".shipping-calculator";

    if (!this.hasAttribute("role")) this.setAttribute("role", "button");
    if (!this.hasAttribute("tabindex")) this.setAttribute("tabindex", "0");
    if (!this.classList.contains("shipping-section__button")) {
      this.classList.add("shipping-section__button");
    }

    const isHidden = () => {
      const calc =
        this.querySelector(".shipping-calculator") ||
        document.querySelector(this.targetSelector);
      if (!calc) return false;
      return (
        calc.hasAttribute("hidden") ||
        calc.classList.contains("hidden") ||
        calc.style.display === "none"
      );
    };

    this._onClick = (e) => {
      if (isHidden()) {
        e.preventDefault();
        this.showCalculator();
      }
    };
    this._onKeyDown = (e) => {
      if ((e.key === "Enter" || e.key === " ") && isHidden()) {
        e.preventDefault();
        this.showCalculator();
      }
    };
    this.addEventListener("click", this._onClick);
    this.addEventListener("keydown", this._onKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._onClick);
    this.removeEventListener("keydown", this._onKeyDown);
  }

  showCalculator() {
    let calc = this.querySelector(".shipping-calculator");
    if (!calc) calc = document.querySelector(this.targetSelector);
    if (!calc) return;

    calc.removeAttribute("hidden");
    calc.classList.remove("hidden");
    if (calc.style && calc.style.display === "none") calc.style.display = "";
    calc.classList.add("is-visible");

    this.classList.add("is-open");
    this.setAttribute("aria-expanded", "true");

    const localInput = this.querySelector(".shipping-calculator-input");
    const globalInput = calc.querySelector?.(".shipping-calculator-input");
    const input = localInput || globalInput;
    try {
      input?.focus({ preventScroll: true });
    } catch (e) {
      /* no-op */
    }

    const form = (calc || this).querySelector(".shipping-calculator-form");
    const results = (calc || this).querySelector(".shipping-results");
    if (!form) return;

    form.addEventListener(
      "submit",
      async (ev) => {
        ev.preventDefault();
        const pc = input && typeof input.value === "string" ? input.value.trim() : "";
        if (!results) return;

        if (pc.length !== 4) {
          results.innerHTML = `<div class="shipping-result-row error">Please enter a valid 4-digit Australian postcode.</div>`;
          return;
        }

        const submitBtn = (calc || this).querySelector(".shipping-calculator-button");
        const spinner = submitBtn?.querySelector?.(".loading-spinner");
        const btnText = submitBtn?.querySelector?.(".button-text");

        const setLoading = (/** @type {boolean} */ on) => {
          if (!submitBtn) return;
          submitBtn.classList.toggle("is-loading", on);
          submitBtn.toggleAttribute("disabled", on);
          if (spinner) /** @type {HTMLElement} */ (spinner).style.display = on ? "" : "none";
          if (btnText) /** @type {HTMLElement} */ (btnText).style.display = on ? "none" : "block";
        };

        setLoading(true);
        try {
          const hasProductDimensions = this.dataset.weight !== undefined;

          if (hasProductDimensions) {
            await this._fetchMergedRates(pc, /** @type {HTMLElement} */ (results));
          } else {
            await this._fetchShopifyRates(pc, /** @type {HTMLElement} */ (results));
          }
        } catch (error) {
          console.error("Shipping error:", error);
          results.innerHTML = `<div class="shipping-result-row error">There was an error retrieving shipping rates.</div>`;
        } finally {
          setLoading(false);
        }
      },
      { passive: false }
    );
  }

  /**
   * Checks whether free shipping applies for the given postcode.
   *
   * Two independent rules — passing EITHER grants free shipping (OR):
   *   Rule 1 — Collection rule: product belongs to one of FREE_SHIPPING_COLLECTION_IDS.
   *                             Bypasses heavy/threshold/state checks entirely.
   *   Rule 2 — Default rule:    NOT heavy AND subtotal >= threshold AND state not excluded.
   *
   * The "Standard" method-name match is enforced at render time, not here.
   *
   * Reads from element data attributes (set via Liquid):
   *   data-fs-shipping-name    — freeshipping.shipping_name           — service label to display as Free
   *   data-fs-threshold        — freeshipping.threshold               — minimum cart subtotal (dollars, decimal)
   *   data-fs-state            — freeshipping.state                   — excluded state codes e.g. "WA,NT,TAS"
   *   data-fs-is-heavy         — variant.metafields.global.ship_heavy — "true" if current variant is heavy
   *   data-fs-cart-has-heavy   — Liquid-rendered boolean              — "true" if any cart line item variant is heavy
   *   data-collection-ids      — product.collections ids (csv)        — used by the collection rule
   *
   * @param {string} postcode
   * @returns {Promise<{ label: string } | null>}
   */
  async _checkFreeShipping(postcode) {
    const shippingName = (this.dataset.fsShippingName || "").trim();
    console.group("[FreeShipping] Check for postcode:", postcode);

    if (!shippingName) {
      console.log("↳ SKIP — data-fs-shipping-name not configured");
      console.groupEnd();
      return null;
    }

    console.log("↳ Config:", {
      shippingName,
      threshold: this.dataset.fsThreshold || "(none)",
      excludedStates: this.dataset.fsState || "(none)",
      isHeavy: this.dataset.fsIsHeavy || "(none)",
      cartHasHeavy: this.dataset.fsCartHasHeavy || "(none)",
      collectionIds: this.dataset.collectionIds || "(none)",
    });

    // Rule 1 — Collection override.
    // Products in any of these collections qualify regardless of heavy / threshold / state.
    const FREE_SHIPPING_COLLECTION_IDS = ["465640128754"];
    const productCollectionIds = (this.dataset.collectionIds || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    const matchedCollectionId = productCollectionIds.find((id) =>
      FREE_SHIPPING_COLLECTION_IDS.includes(id)
    );
    if (matchedCollectionId) {
      console.log(`↳ APPROVED (collection rule) — product in collection ${matchedCollectionId}`);
      console.groupEnd();
      return { label: shippingName };
    }

    // Rule 2 — Default heavy / threshold / state checks.
    if (this.dataset.fsIsHeavy === "true") {
      console.log("↳ DENIED — current variant is flagged ship_heavy");
      console.groupEnd();
      return null;
    }
    if (this.dataset.fsCartHasHeavy === "true") {
      console.log("↳ DENIED — a cart line item variant is flagged ship_heavy");
      console.groupEnd();
      return null;
    }

    const threshold = parseFloat(this.dataset.fsThreshold || "0");
    if (threshold > 0) {
      try {
        const cart = await fetch("/cart.json").then((r) => r.json());
        let subtotal = cart.total_price / 100;

        // Include the current product's price in the subtotal calc when the
        // shopper is on a PDP and the variant hasn't been added to cart yet.
        // data-price is rendered in cents (Shopify convention).
        const currentVariantId = this.dataset.variantId || "";
        const currentPriceCents = parseInt(this.dataset.price || "0", 10) || 0;
        const isAlreadyInCart =
          currentVariantId &&
          Array.isArray(cart.items) &&
          cart.items.some((item) => String(item.variant_id) === String(currentVariantId));

        if (currentVariantId && !isAlreadyInCart && currentPriceCents > 0) {
          const productPrice = currentPriceCents / 100;
          subtotal += productPrice;
          console.log(
            `↳ Added current product price $${productPrice.toFixed(2)} to subtotal (variant ${currentVariantId} not in cart)`
          );
        }

        console.log(`↳ Cart subtotal: $${subtotal.toFixed(2)} — threshold: $${threshold.toFixed(2)}`);
        if (subtotal < threshold) {
          console.log(`↳ DENIED — subtotal $${subtotal.toFixed(2)} < threshold $${threshold.toFixed(2)}`);
          console.groupEnd();
          return null;
        }
        console.log("↳ Threshold PASSED");
      } catch (err) {
        console.warn("↳ DENIED — failed to fetch cart.json:", err);
        console.groupEnd();
        return null;
      }
    }

    const excludedStates = (this.dataset.fsState || "")
      .split(",")
      .map((s) => s.trim().toUpperCase())
      .filter(Boolean);

    if (excludedStates.length > 0) {
      const states = await getStateFromPostcode(postcode);
      const normalised = states.map((s) => s.toUpperCase());
      console.log(`↳ Resolved states: [${normalised.join(", ") || "unknown"}] — excluded: [${excludedStates.join(", ")}]`);
      const isExcluded = normalised.some((s) => excludedStates.includes(s));
      if (isExcluded) {
        console.log(`↳ DENIED — [${normalised.filter((s) => excludedStates.includes(s)).join(", ")}] in excluded list`);
        console.groupEnd();
        return null;
      }
      console.log(`↳ State PASSED — none of [${normalised.join(", ")}] in excluded list`);
    }

    console.log(`↳ APPROVED — will show "${shippingName}: Free"`);
    console.groupEnd();
    return { label: shippingName };
  }

  /**
   * Normalises a shipping label to a comparison key by lowercasing
   * and stripping common suffixes like " shipping" and " delivery".
   * e.g. "Standard Shipping" → "standard", "Express Delivery" → "express"
   * @param {string} label
   * @returns {string}
   */
  _normaliseLabel(label) {
    return label
      .toLowerCase()
      .replace(/\s+(shipping|delivery)$/, "")
      .trim();
  }

  /**
   * Inserts a row into the rows array. No deduplication — every rate is shown.
   * @param {Array<{ label: string, price: number }>} rows
   * @param {string} label
   * @param {number} price
   */
  _addRow(rows, label, price) {
    rows.push({ label, price });
  }

  /**
   * Renders rows array to HTML string using the shared row format.
   * @param {Array<{ label: string, price: number }>} rows
   * @returns {string}
   */
  _renderRows(rows) {
    return rows
      .map(({ label, price }) => `
        <div class="shipping-result-row">
          <span class="result-label">${label}:</span>
          <span class="result-value">${price === 0 ? "Free" : "$" + price.toFixed(2)}</span>
        </div>
      `)
      .join("");
  }

  /**
   * Strategy: Shopify draftOrderCalculate is primary (it mirrors checkout exactly).
   * Shippit is called only as a fallback when Shopify returns no rates
   * (edge case: products with continue-selling-when-OOS where draftOrderCalculate
   * returns "Shipping not available").
   *
   * Free shipping rule is gated on Shopify rates containing a "Standard" method.
   *
   * @param {string} postcode
   * @param {HTMLElement} results
   */
  async _fetchMergedRates(postcode, results) {
    const [freeShipping, shopifyData] = await Promise.allSettled([
      this._checkFreeShipping(postcode),
      getShippingRates(postcode, this.dataset.variantId || ""),
    ]);

    const shopifyRates =
      shopifyData.status === "fulfilled" && Array.isArray(shopifyData.value?.shipping_rates)
        ? shopifyData.value.shipping_rates
        : [];

    /** @type {Array<{ label: string, price: number }>} */
    const rows = [];

    if (shopifyRates.length > 0) {
      const isFreeShippingValid =
        freeShipping.status === "fulfilled" && Boolean(freeShipping.value);

      for (const rate of shopifyRates) {
        const title = rate.title || "";
        const isStandard = title.toLowerCase().includes("standard");
        const price = isFreeShippingValid && isStandard ? 0 : Number(rate.price.amount);
        this._addRow(rows, title, price);
      }

      if (isFreeShippingValid && !rows.some((r) => r.price === 0)) {
        console.log('[FreeShipping] qualified but no Shopify rate with title containing "Standard" — nothing to mark Free');
      }

      results.innerHTML = this._renderRows(rows);
      return;
    }

    // Fallback: Shopify returned empty (e.g. OOS continue-selling product).
    // Try Shippit as best-effort estimate. Free shipping rule is skipped here
    // because we can't verify it would apply at checkout without Shopify rates.
    console.log("[ShippingDebug] Shopify returned no rates — falling back to Shippit");
    const shippitData = await getShippitRates({
      postcode,
      weightGrams: parseInt(this.dataset.weight || "1000") || 1000,
      widthMm: parseInt(this.dataset.width || "0") || 0,
      heightMm: parseInt(this.dataset.height || "0") || 0,
      depthMm: parseInt(this.dataset.depth || "0") || 0,
    });

    if (shippitData?.response?.length > 0) {
      for (const service of shippitData.response) {
        const firstQuote = service.quotes && service.quotes[0];
        if (!firstQuote) continue;
        const label =
          typeof service.service_level === "string" && service.service_level.length
            ? service.service_level.charAt(0).toUpperCase() + service.service_level.slice(1)
            : service.courier_type || "";
        this._addRow(rows, label, firstQuote.price);
      }
    }

    if (rows.length === 0) {
      results.innerHTML = `<div class="shipping-result-row error">No rates found for this postcode.</div>`;
      return;
    }

    results.innerHTML = this._renderRows(rows);
  }

  /**
   * Calls free shipping check and Shopify API in parallel.
   * Priority: free > checkout rates.
   * @param {string} postcode
   * @param {HTMLElement} results
   */
  async _fetchShopifyRates(postcode, results) {
    const [freeShipping, shopifyData] = await Promise.allSettled([
      this._checkFreeShipping(postcode),
      getShippingRates(postcode, this.dataset.variantId || ""),
    ]);

    /** @type {Array<{ label: string, price: number }>} */
    const rows = [];

    const shopifyRates =
      shopifyData.status === "fulfilled" && Array.isArray(shopifyData.value?.shipping_rates)
        ? shopifyData.value.shipping_rates
        : [];

    const isFreeShippingValid =
      freeShipping.status === "fulfilled" && Boolean(freeShipping.value);

    for (const rate of shopifyRates) {
      const title = rate.title || "";
      const isStandard = title.toLowerCase().includes("standard");
      const price = isFreeShippingValid && isStandard ? 0 : Number(rate.price.amount);
      this._addRow(rows, title, price);
    }

    if (isFreeShippingValid && !rows.some((r) => r.price === 0)) {
      console.log('[FreeShipping] qualified but no Shopify rate with title containing "Standard" — nothing to mark Free');
    }

    if (rows.length === 0) {
      results.innerHTML = `<div class="shipping-result-row error">No rates found for this postcode.</div>`;
      return;
    }

    results.innerHTML = this._renderRows(rows);
  }
}

if (!customElements.get("shipping-calc-toggle")) {
  customElements.define("shipping-calc-toggle", ShippingCalcToggle);
}
